import { lazy } from 'react';
import { type RouteObject } from 'react-router-dom';
import { paths } from '@/shared/config/paths';

const ContestCreate = lazy(() => import('@pages/contest/contest/ContestCreate'));
const ContestUpdate = lazy(() => import('@pages/contest/contest/ContestEdit'));
const TopBannerCreate = lazy(() => import('@/pages/mainSection/topBanner/TopBannerCreate'));
const ProgramCreate = lazy(() => import('@pages/program/program/ProgramCreate'));
const ProgramEdit = lazy(() => import('@pages/program/program/ProgramEdit'));
const SessionCreate = lazy(() => import('@pages/program/session/SessionCreate'));

// 전체 화면 페이지
export const fullScreenRoutes: RouteObject[] = [
	// 메인 최상단배너
	{
		path: paths.mainSection.topBanner.new,
		element: <TopBannerCreate />,
		handle: {
			title: '메인 최상단 배너 대회 추가',
			subTitle: '락앤런 대회·프로그램 중 메인 배너 추가',
		},
	},
	// 대회
	{
		path: paths.contest.contest.new,
		element: <ContestCreate />,
		handle: {
			title: '새 대회 등록',
			subTitle: '새로운 대회 등록하기',
		},
	},
	{
		path: paths.contest.contest.edit,
		element: <ContestUpdate />,
		handle: {
			title: '대회 수정',
			subTitle: '등록한 대회 수정하기',
		},
	},
	// 프로그램
	{
		path: paths.program.program.new,
		element: <ProgramCreate />,
		handle: {
			title: '새 프로그램 등록',
			subTitle: '새로운 회차 프로그램 등록하기',
		},
	},
	{
		path: paths.program.program.edit,
		element: <ProgramEdit />,
		handle: {
			title: '프로그램 수정',
			subTitle: '등록한 프로그램 수정하기',
		},
	},
	// 프로그램 회차
	{
		path: paths.program.session.new,
		element: <SessionCreate />,
		handle: {
			title: '프로그램 회차 등록',
			subTitle: '프로그램 진행 회차 등록하기',
		},
	},
];
